import React from 'react';

interface ButtonProps {
    text: string,
    full?: boolean,
    disabled?: boolean
    onClick?: () => void
}

const activeCss = "bg-cyan-600 hover:bg-cyan-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-100"
const disabledCss = "bg-gray-300"

function Button(props: ButtonProps) {

    const css = [
        props.full ? 'w-full' : '',
        props.disabled ? disabledCss : activeCss
    ].join(" ")

    return <button
        onClick={props.onClick}
        disabled={props.disabled || false}
        className={css + ' rounded-md px-3.5 py-2.5 text-lg font-semibold text-white shadow-sm'} >
        {props.text}
    </button>
}

export default Button;